// DivisionModal.js
import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Icon,
  FormControl,
  FormLabel,
  useToast,
} from "@chakra-ui/react";
import { FaUserTie, FaPlus } from "react-icons/fa";
import { BASE_URL } from "../../Globalapi/Globalapi";

const DivisionModal = ({ isOpen, onClose }) => {
  const [divisionName, setDivisionName] = useState("");
  const toast = useToast();

  const handleCreateDivision = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/admin/division/create_division.php`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            division: divisionName,
            pass: sessionStorage.getItem("user_id"), // Replace with the actual password or user ID as needed
          }),
        }
      );

      const data = await response.json();
      if (data.success) {
        toast({
          title: "Division created successfully.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        onClose();
      } else {
        throw new Error(data.message || "Failed to create division");
      }
    } catch (error) {
      toast({
        title: "Error",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Modal
    isCentered
      isOpen={isOpen}
      onClose={onClose}
      size="lg"
      motionPreset="slideInBottom"
    >
      <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
      <ModalContent
        borderRadius="lg"
        boxShadow="xl"
        bg="linear-gradient(135deg, #e0f7f7, #f0ffff)"
        color="gray.700"
        p={6}
        maxW="700px"
        maxH="550px"
        overflowY="auto"
      >
        <ModalHeader
          fontSize="xl"
          fontWeight="bold"
          textAlign="center"
          color="teal.600"
        >
          <Icon as={FaPlus} boxSize={5} mr={2} />
          Create Division
        </ModalHeader>
        <ModalBody>
          <FormControl>
            <FormLabel>Division Name</FormLabel>
            <Input
              bg="white"
              _hover={{ borderColor: "teal.300" }}
              value={divisionName}
              onChange={(e) => setDivisionName(e.target.value)}
              placeholder="Enter division name"
            />
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button
            bgGradient="linear(to-r, teal.400, teal.600)"
            color="white"
            _hover={{ bgGradient: "linear(to-r, teal.500, teal.700)" }}
            colorScheme="teal"
            onClick={handleCreateDivision}
          >
            Create
          </Button>
          {/* <Button onClick={onClose} ml={3}>
            Cancel
          </Button> */}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DivisionModal;
